import agent from '@/api/agent';
import * as types from './mutationTypes';

export default {
  fetchDefaultAgents({ commit, state }) {
    let icsToFetch = null;
    switch (state.filters.icsType) {
      case 'i':
        icsToFetch = 'industrial';
        break;
      case 'c':
        icsToFetch = 'commercial';
        break;
      case 's':
        icsToFetch = 'shop';
        break;
      default:
        icsToFetch = 'ics';
        break;
    }

    const empType = [];
    if (state.filters.isMitaclub) {
      empType.push('mitaclub');
    }
    if (state.filters.isManager) {
      empType.push('manager');
    }
    if (state.filters.isSales) {
      empType.push('sales');
    }

    const query = {
      ics: `mr-${icsToFetch}`,
      limit: state.pageSize,
      page: 1,
      keywords: state.filters.keywords,
      districts: state.filters.districts,
      emp_type: empType,
    };

    commit(types.START_FETCH_AGENTS, query);
    return agent
      .getAgents({
        ...state.query,
      })
      .then((agents) => {
        commit(types.SET_FETCHED_AGENTS, agents);
        commit(types.SET_FETCHED_AGENT_COUNT, agents.count);
      })
      .catch((e) => {
        commit(types.FETCH_AGENTS_ERROR, `failed get agents: ${e}`);
      });
  },

  fetchMoreAgents({ commit, state }) {
    commit(types.START_FETCH_MORE_AGENTS);
    const fetchMoreQuery = state.query;
    fetchMoreQuery.page = state.page;
    return agent
      .getAgents({
        ...fetchMoreQuery,
      })
      .then((agents) => {
        if (agents.result.length > 0) {
          commit(types.APPEND_FETCHED_AGENTS, agents.result);
        } else {
          commit(types.FETCH_ENDED);
        }
      })
      .catch((e) => {
        commit(types.FETCH_AGENTS_ERROR, `failed get agents: ${e}`);
      });
  },

  fetchByPage({ dispatch, commit }, page) {
    commit(types.SET_PAGE, page);
    return dispatch('fetchMoreAgents');
  },

  updateFilter({ dispatch, commit }, filters) {
    Object.keys(filters).forEach((filterKey) => {
      commit(types.SET_FILTER, {
        [filterKey]: filters[filterKey],
      });
    });

    return dispatch('fetchDefaultAgents');
  },

  updateDistrictFilter({ dispatch, commit, state }, actions) {
    const districts = state.filters.districts || [];
    Object.keys(actions).forEach((distCode) => {
      const selected = actions[distCode];
      const idx = districts.findIndex(dc => dc === distCode);
      if (selected && idx === -1) {
        districts.push(distCode);
      }
      if (!selected && idx !== -1) {
        districts.splice(idx, 1);
      }
    });

    commit(types.SET_FILTER, { districts });

    return dispatch('updateFilter', state.filters);
  },

  setIcsType({ commit }, payload) {
    commit(types.SET_ICS_TYPE, payload);
  },
};
